import { graphql } from "@opensea/graphql"
import { BackgroundOnlyFragment } from "./components/BackgroundOnly/BackgroundOnly.fragment"
import { TextOnlyFragment } from "./components/TextOnly/TextOnly.fragment"
import { TextWithBackgroundFragment } from "./components/TextWithBackground/TextWithBackground.fragment"
import { TextWithMediaFragment } from "./components/TextWithMedia/TextWithMedia.fragment"

export const NarrativeModuleFragment = graphql(
  `
    fragment NarrativeModule on CollectionNarrativeModule {
      variant
      ...BackgroundOnly
      ...TextWithBackground
      ...TextWithMedia
      ...TextOnly
    }
  `,
  [
    BackgroundOnlyFragment,
    TextWithBackgroundFragment,
    TextWithMediaFragment,
    TextOnlyFragment,
  ],
)
